<template>
    <div class="transformerView">
        <div class="title">基本信息</div>
        <div class="overview">
            <div class="message">
                <h1>{{inverter.loop_name}}</h1>
                <p>类型：{{inverter.device_type_name}}</p>
                <p>型号：{{inverter.device_model_name}}</p>
                <p>品牌：{{inverter.device_brand_name}}</p>
                <p>站点：{{inverter.area_name}}</p>
            </div>
            <div class="load">
                <div class="realtime">
                    <p>逆变器状态</p>
                    <p>{{mqttval(inverterSubloopRul + '/SwitchOn') == 0?'运行':'关闭'}}</p>
                </div>
            </div>
            <div class="loadcap">
                <div class="realtime">
                    <p>日发电量</p>
                    <p :class="todayPower[0] == '--'? 'grey':''">{{todayPower[0]}} <span v-show="todayPower[0] !== '--'">kWh</span></p>
                </div>
                <div class="realtime ">
                    <p>累计发电量</p>
                    <p :class="todayPower[1] == '--'? 'grey':''">{{todayPower[1]}} <span v-show="todayPower[1] !== '--'">kWh</span></p>
                </div>
            </div>
        </div>
        <div class="transformerEnty">
            
            <div class="heightLow">
                <div class="tab">
                    <span class="se">交流侧</span>
                </div>
                <div class="box">
                    <div class="boxItem" v-for="item in heightArr" :key="item.id">
                        <div class="val"><span>{{item.name}}</span></div>
                        <!-- <div class="val"><span>{{mqttval(inverterSubloopRul + item.val)}}<i> {{item.unit}}</i></span></div> -->
                        <div class="val" ><span :class="mqttval(inverterSubloopRul + item.val) == '--'? 'grey':(mqttval(inverterSubloopRul + item.val) / item.multiple) > 10000?'alarm':''">{{mqttval(inverterSubloopRul + item.val) == '--'?'--': (mqttval(inverterSubloopRul + item.val) / item.multiple).toFixed(2)}}<i v-show="mqttval(inverterSubloopRul + item.val) !== '--'"> {{item.unit}}</i></span></div>
                    </div>
                </div>
            </div>
            <div class="enty">
                <div class="tem">
                    机内空气温度：<span :class="mqttval(inverterSubloopRul + '/Temperature') == '--'? 'grey':''">{{mqttval(inverterSubloopRul + '/Temperature') == '--'?'--':mqttval(inverterSubloopRul + '/Temperature') + ' ℃'}}</span>
                </div>
            </div>
            <div class="heightLow">
                <div class="tab">
                    <span class="se">直流侧</span>
                </div>
                <div class="box">
                    <div class="boxItem2" >
                        <div class="val"><span>电压</span></div>
                        <div class="val"><span :class="mqttval(inverterSubloopRul + '/U') == '--'? 'grey':''">{{mqttval(inverterSubloopRul + '/U')}}<i v-show="mqttval(inverterSubloopRul + '/U') !== '--'"> V</i></span></div>
                    </div>
                    <div class="boxItem2" >
                        <div class="val"><span>电流</span></div>
                        <div class="val"><span :class="mqttval(inverterSubloopRul + '/I') == '--'? 'grey':''">{{mqttval(inverterSubloopRul + '/I')}}<i v-show="mqttval(inverterSubloopRul + '/I') !== '--'"> A</i></span></div>
                    </div>
                    <div class="boxItem2" >
                        <div class="val"><span>功率</span></div>
                        <div class="val"><span :class="mqttval(inverterSubloopRul + '/--') == '--'? 'grey':''">{{mqttval(inverterSubloopRul + '/--')}}<i v-show="mqttval(inverterSubloopRul + '/--') !== '--'"> kW</i></span></div>
                    </div>
                </div>
            </div>
            
        </div>
    </div>
</template>

<script>
import { getPowerloopMax } from '../../../api/power.js'
import { dayStart, dayEnd } from '../../../util/DateUtil'
export default {
    props:['inverter'],
    data(){
        return {
            options:{
                positiveColor:'#5AD8A6',
            }, 
            todayPower:['--', '--'],
            heightArr:[
                {
                    id:1,
                    name:'A相电压',
                    val:'/Ua',
                    unit:'V',
                    multiple:1
                },
                {
                    id:2,
                    name:'A相电流',
                    val:'/Ia',
                    unit:'A',
                    multiple:1
                },
                {
                    id:3,
                    name:'B相电压',
                    val:'/Ub',
                    unit:'V',
                    multiple:1
                },
                {
                    id:4,
                    name:'B相电流',
                    val:'/Ib',
                    unit:'A',
                    multiple:1
                },
                {
                    id:5,
                    name:'C相电压',
                    val:'/Uc',
                    unit:'V',
                    multiple:1
                },
                {
                    id:6,
                    name:'C相电流',
                    val:'/Ic',
                    unit:'A',
                    multiple:1
                },
                {
                    id:7,
                    name:'有功功率',
                    val:'/PA',
                    unit:'kW',
                    multiple:1000
                },
                {
                    id:8,
                    name:'无功功率',
                    val:'/PR',
                    unit:'kVar',
                    multiple:1000
                },
                {
                    id:9,
                    name:'视在功率',
                    val:'/P',
                    unit:'kVA',
                    multiple:1000
                },
                {
                    id:10,
                    name:'功率因数',
                    val:'/PF',
                    unit:'',
                    multiple:1
                },
                {
                    id:11,
                    name:'频率',
                    val:'/F',
                    unit:'Hz',
                    multiple:1
                },
            ]
        }
    },
    components:{
    },
    computed:{
        mqttval() {
			return this.getMqttVal(this.$store.getters.mqttVal);
		},
        inverterSubloopRul(){
            return this.inverter.loop_url.split('/').splice(1).join('/')
        }
    },
    watch:{
        inverter(val){
            console.log(val);
            this.getPowerVal()
        }
    },
    mounted(){
        this.getPowerVal()
    },
    methods:{
        getMqttVal(f) {
			return (k, m) => {
				if (k) {
				let mqttVal = f(k);
				if (m) {
					mqttVal *= m;
				}
				mqttVal = Number(mqttVal).toFixed(2);
				if (typeof mqttVal === "object") {
					return mqttVal;
				}
				return mqttVal !== undefined && !isNaN(mqttVal) ? mqttVal : "--";
				} else {
				return "--";
				}
			};
		},
        async getPowerVal(){
            let today = dayStart(new Date())
            let end = dayEnd(new Date())
            
            let promiseAll = [getPowerloopMax({
                loopId:this.inverter.loop_id,
                node:'Daily_Power_Generation',
                start:today,
                end:end

            }),getPowerloopMax({
                loopId:this.inverter.loop_id,
                node:'Total_Power_Generation',
                start:today,
                end:end
            })]
            let arr = []
            try{
                let res = await Promise.all(promiseAll)
                console.log(res);
                res.forEach((item, index) =>{
                    if(item.data.code == 200){
                        arr[index] = Number(item.data.data.last).toFixed(2)
                    }else {
                        console.log('err:' + res.data.errMsg);
                    }
                })
                this.todayPower = arr
            } catch(err){
                console.log(err);
            }
            
        }
    }
}
</script>

<style lang="less" scoped>
.transformerView{
    width: 100%;
    .title{
        font-size: 18rem;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #333333;
        padding-bottom: 0.6vh;
        border-bottom:1px solid rgba(0, 0, 0, 0.15) ;
        padding-left: 0.7vw;
        position: relative;
        &::before{
            content:'';
            width: 0.3vw;
            height: 2vh;
            background-color: #0D94FF;
            position: absolute;
            top: 40%;
            left: 0;
            transform: translate(0, -50%);
        }
    }
    .overview{
        height: 16vh;
        box-sizing: border-box;
        padding: 1vh 0;
        display: flex;
        justify-content: space-between;

        .message{
            width:27% ;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: flex-start;
            &>h1{
                font-size: 24rem;
                font-family: Source Han Sans CN;
                font-weight: bold;
                color: #333333;
            }
            &>p{
                font-size: 18rem;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #666666;
            }
        }

        .load{
            width: 18%;
            padding: 20rem;
            height: 100%;
            background: rgba(0,43,102, 0.04);
            border-radius:5rem;

            .realtime{
                width: 100%;
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                &>p{
                    padding: 1vh 0;
                }
                &>p:nth-child(1){
                    font-size: 18rem;
                    font-family: Source Han Sans CN;
                    font-weight: 500;
                    color: #333333;
                }
                &>p:nth-child(2){
                    font-size: 24rem;
                    font-family: Source Han Sans CN;
                    font-weight: bold;
                    color: #269A99;
                }
            }
        }

        .loadcap{
            width: 50%;
            height: 100%;
            background: rgba(0,43,102, 0.04);
            border-radius:5rem;
            display: flex;
            .realtime{
                width: 50%;
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                &>p{
                    padding: 1vh 0;
                }
                &>p:nth-child(1){
                    font-size: 18rem;
                    font-family: Source Han Sans CN;
                    font-weight: 500;
                    color: #333333;
                }
                &>p:nth-child(2){
                    font-size: 24rem;
                    font-family: Source Han Sans CN;
                    font-weight: bold;
                    color: #0D94FF;
                    &>span{
                        font-size: 20rem;
                    }
                }
            }
        }
    }

    .transformerEnty{
        height: 28vh;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .enty{
            width:33% ;
            height: 100%;
            background: url('../.././../assets/img/ninbianqi.png') no-repeat;
            background-size: 100% 80%;
            background-position: 50% 80%;
            border: 1px solid #E5E5E5;
            box-shadow: 0px 0px 16px 0px rgba(0,43,102,0.08);
            position: relative;
            .tem{
                position: absolute;
                top: 7%;
                right: 17%;
                font-size: 16rem;
                font-family: Source Han Sans CN;
                font-weight: bold;
                color: #333333;
                text-shadow: -1px 1px 0 #fff, 1px 1px 0 #fff, 1px -1px 0 #fff, -1px -1px 0 #fff;
                &>span{
                    font-size: 18rem;
                    color: #0D94FF;
                    
                }
                
            }

        }
        .heightLow{
            width: 43%;
            height: 100%;
            .tab{
                width: 100%;
                height: 4.5vh;
                display: flex;
                align-items: center;

                &>span{
                    display: inline-block;
                    margin: 0 15rem;
                    position: relative;
                    color: #333;
                    font-size: 18rem;
                    font-weight: bold;
                    &::before{
                        content:'';
                        width: 100%;
                        height: 3rem;
                        background-color: none;
                        border-radius: 1.5rem;
                        position: absolute;
                        top: 130%;
                        left: 0;
                    }
                }
                .se{
                    color:#0D94FF ;
                    &::before{
                        content:'';
                        background-color: #0D94FF;
                    }
                }
            }
            .box{
                width: 100%;
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                border-top:1px solid rgba(0, 0, 0, 0.15) ;
                align-content: flex-start;
                .boxItem{
                    width: 50%;
                    height: 3.8vh;
                    display: flex;
                    .val{
                        width: 50%;
                        height: 100%;
                        background:#F5F7F9 ;
                        position: relative;
                        font-size: 16rem;
                        white-space: nowrap;
                        font-family: Source Han Sans CN;
                        font-weight: bold;
                        color: #333333;
                        &>span{
                            position: absolute;
                            left: 20%;
                            top: 50%;
                            transform: translate(0, -50%);
                            &>i{
                                font-size: 16rem;
                            }
                        }
                    }
                    .val:nth-child(2){
                        background:#fff ;
                        color: #0D94FF;
                        font-size: 18rem;
                        &>span{
                            position: absolute;
                            left: 5%;
                            top: 50%;
                            transform: translate(0, -50%);
                            &>i{
                                font-size: 12rem;
                            }
                        }
                        .alarm{
                            color: red;
                        }
                    }
                    
                }
                .boxItem:nth-child(odd){
                    border-left: 1px solid rgba(0, 0, 0, 0.15);
                    border-bottom: 1px solid rgba(0, 0, 0, 0.15);
                    border-right: 1px solid rgba(0, 0, 0, 0.15);
                }
                .boxItem:nth-child(even){
                    border-bottom: 1px solid rgba(0, 0, 0, 0.15);
                    border-right: 1px solid rgba(0, 0, 0, 0.15);
                }
            }
        }
        .heightLow:nth-child(3){
            width: 21%;
            .box{
                .boxItem2{
                    width: 100%;
                    height: 4.5vh;
                    display: flex;
                    border-left: 1px solid rgba(0, 0, 0, 0.15);
                    border-bottom: 1px solid rgba(0, 0, 0, 0.15);
                    border-right: 1px solid rgba(0, 0, 0, 0.15);

                    .val{
                        width: 50%;
                        height: 100%;
                        background:#F5F7F9 ;
                        position: relative;
                        font-size: 16rem;
                        white-space: nowrap;
                        font-family: Source Han Sans CN;
                        font-weight: bold;
                        color: #333333;
                        &>span{
                            position: absolute;
                            left: 20%;
                            top: 50%;
                            transform: translate(0, -50%);
                            &>i{
                                font-size: 14rem;
                            }
                        }
                    }
                    .val:nth-child(2){
                        background:#fff ;
                        color: #0D94FF;
                        font-size: 18rem;
                        width: 50%;
                        &>span{
                            position: absolute;
                            left: 3%;
                            top: 50%;
                            transform: translate(0, -50%);
                            &>i{
                                font-size: 12rem;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>